import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import MobileHelper from "../../../../../helpers/mobile";
import typeCollaboration from "./type-collaboration";

export default function ViewMarketerUserEditLog() {
  const params = useParams();
  const logID = params.logID;
  const [log, setLog] = useState();

  useEffect(() => {
    getLog();
  }, []);

  const getLog = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const log = await sendRequestGetLog(logID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!log) {
      return;
    }
    setLog(log);
  };

  const sendRequestGetLog = async (logID) => {
    const headersRequest = getHeaderForRequest();
    let log;
    try {
      log = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/manage/log-edit/${logID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return log.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="users" activeItem="all-marketer" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">همه کاربران بازاریاب</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to={`/user/marketer/edit/all-log/${log?.log_user_id}`}
                  className="btn btn-primary"
                >
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {log && (
                <div className="table-responsive pt-2">
                  <table className="table table-hilite tbl-td-white-space table-hover m-0">
                    <thead>
                      <tr>
                        <td
                          colSpan={2}
                          className="text-center"
                          style={{ borderRadius: "25px 25px 0 0" }}
                        >
                          اطلاعات بازاریاب
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>شماره کاربری</td>
                        <td>{log.log_user_id}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>شناسه کاربری قبلی</td>
                        <td>{log.log_identity_marketer_before}</td>
                      </tr>
                      <tr>
                        <td>شناسه کاربری بعدی</td>
                        <td>{log.log_identity_marketer_after}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>درصد اولیه قبلی</td>
                        <td>{log.log_first_percent_before}</td>
                      </tr>
                      <tr>
                        <td>درصد اولیه بعدی</td>
                        <td>{log.log_first_percent_after}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>نوع همکاری قبلی</td>
                        <td>
                          {
                            typeCollaboration.getTypeCollaborationString()[
                              log.log_type_collaboration_before
                            ]
                          }
                        </td>
                      </tr>
                      <tr>
                        <td>نوع همکاری بعدی</td>
                        <td>
                          {
                            typeCollaboration.getTypeCollaborationString()[
                              log.log_type_collaboration_after
                            ]
                          }
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>درصد دائمی قبلی</td>
                        <td>{log.log_permanent_percent_before}</td>
                      </tr>
                      <tr>
                        <td>درصد دائمی بعدی</td>
                        <td>{log.log_permanent_percent_after}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>تعداد درصد دائمی قبلی</td>
                        <td>{log.log_count_permanent_percent_before}</td>
                      </tr>
                      <tr>
                        <td>تعداد درصد دائمی بعدی</td>
                        <td>{log.log_count_permanent_percent_after}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>فعال قبلی</td>
                        <td>
                          {log.log_active_before ? (
                            <span class="badge badge-success">فعال</span>
                          ) : (
                            <span class="badge badge-danger">غیرفعال</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>فعال بعدی</td>
                        <td>
                          {log.log_active_after ? (
                            <span class="badge badge-success">فعال</span>
                          ) : (
                            <span class="badge badge-danger">غیرفعال</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>تاریخ ثبت نام</td>
                        <td>
                          {helpersNumber.toPersianNum(
                            helpersTime.convertGregorianToJalali(
                              log.log_created_at
                            ) +
                              " " +
                              log.log_created_at.split(" ")[1]
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
